import { render } from "./LottoHomeView.vue?vue&type=template&id=5f1266dd&ts=true"
import script from "./LottoHomeView.vue?vue&type=script&lang=ts"
export * from "./LottoHomeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__